<template>
  <sl-side-panel v-model="visible" :transfer="false" :title="title" :loading="loading" :footer-visible="false">
    <div slot="header">

      <Button ghost @click="handleQueryLoan" v-if="enableQueryLoan">获取贷款方案</Button>
      <Button ghost @click="handleApply" v-if="enableApply">发起申请</Button>
      <Button ghost @click="handleVerifyLoan" v-if="enableVerifyLoan">面签数据校验</Button>
      <Button ghost @click="handlePushNotify" v-if="enablePushNotify">签约推送</Button>

    </div>
    <Tabs :animated="false">
      <TabPane label="基础信息">
        <Row :gutter="12">
          <Col span="12">
            <sl-label title="订单状态" :content="data.info.orderStateText" />
          </Col>
          <Col span="12">
            <sl-label title="分期状态" :content="stateText" />
          </Col>
          <Col span="24">
            <sl-label title="备注" :content="data.info.remark" />
          </Col>
        </Row>
        <Divider>补充信息</Divider>
        <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="130">
          <FormItem label="运费（元）" prop="postFee">
            <InputNumber v-model="form.postFee" :min="0" :precision="2" :active-change="false"></InputNumber>
          </FormItem>
          <FormItem label="保险费（元）" prop="insuranceFee">
            <InputNumber v-model="form.insuranceFee" :min="0" :precision="2" :active-change="false"></InputNumber>
          </FormItem>
          <FormItem label="业务员姓名">
            <Input v-model="form.salesmanName"></Input>
          </FormItem>
          <FormItem label="业务员手机号">
            <Input v-model="form.salesmanPhone"></Input>
          </FormItem>
          <FormItem label="采购金额（元）">
            <InputNumber v-model="form.purchaseAmount" :min="0" :precision="2" :active-change="false"></InputNumber>
          </FormItem>
          <FormItem label="裸车金额（元）">
            <InputNumber v-model="form.bareAmount" :min="0" :precision="2" :active-change="false"></InputNumber>
          </FormItem>
          
          <FormItem>
            <Button @click="reset">重置</Button>
            <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
          </FormItem>
        </Form>
        <Divider>流程日志</Divider>
        <order-flow-log :data="flowLogs"></order-flow-log>
      </TabPane>

      <TabPane label="分期产品">
        <order-installment :datas="data.finance"></order-installment>
      </TabPane>

      <TabPane label="借款方信息" v-if="isPersonalType">
        <order-debtor-person :order-id="id" ></order-debtor-person>
      </TabPane>
    </Tabs>
  </sl-side-panel>
</template>
<script>

import orderInstallment from './partial/installment'
import orderInsurance from './partial/insurance'
import orderFlowLog from './partial/flowLog'
import orderDebtor from './partial/debtor'
import orderDebtorPerson from './partial/debtorPerson'
import orderFinanceInfo from './partial/financeInfo'

const createLabel = (fields , data ,h) => fields.map(i => {
    return h('sl-label' , {
      props: {
        labelWidth:120,
        title: i.label,
        content: data[i.key],
      }
    })
  })

export default {
  components: { orderInstallment , orderInsurance , orderFlowLog , orderDebtor , orderDebtorPerson , orderFinanceInfo},

  data() {
    return {
      loading: false,
      id: null,
      rules:{},
      data:{
        info:{} , 
        annexs:[],
        finance:{}
      },
      form:{
        id:null,
        postFee:null,
        insuranceFee:null,
        totalAmount:null,
        salesmanName:null,
        salesmanPhone:null,
        purchaseAmount:null,
        bareAmount:null,
      },
      title:'',
      visible:false,
      flowLogs:[],
      buySubject:0
    }
  },

  mounted() {},
  computed:{
    stateText(){
      switch(this.data.info.flowState){
        case 5:
          return '未申请'
        case 6:
          return '申请中'
        case 7:
          return '分期签约推送'
        case 8:
          return '分期成功'
        case 9:
          return '分期失败' 
      }
    },

    isPersonalType(){
      return this.data.info.buySubject == 0
    },

    enableQueryLoan(){
      return this.data.info.flowState == 5 && this.isPersonalType
    },
    //发起申请
    enableApply(){
      return (this.data.info.flowState == 5 && this.isPersonalType || !this.isPersonalType)
    },

    enableVerifyLoan(){
      return this.data.info.flowState == 6 && this.isPersonalType
    },

    enablePushNotify(){
      return !this.isPersonalType
    }
  },
  methods: {
    query() {
      if (this.id) {
        this.loading = true
        this.$request.order(this.id).then(resp => {
          if( !resp.code ){
            this.$utils.conv(resp.data.info,{'dealDatetime':'time' , 'cancelDatetime':'time' , 'payType':'$payType' , 'orderState':'$orderState'})
           
            this.data = resp.data

            this.data.annexs = resp.data.annexs || []

            this.data.finance = resp.data.finance || { orderId : this.id }

            this.data.finance.flowState = resp.data.info.flowState

            this.data.finance.goods = resp.data.goods.map( i => i.skuId )

            this.data.finance.totalAmount = resp.data.info.totalAmount
            
            this.data.finance.buySubject = resp.data.info.buySubject

            this.flowLogs = resp.data.flowLogs || []

            this.buySubject = this.data.info.buySubject 
      
            this.$utils.fill( this.form , resp.data.info )
            this.loading = false
          }
        })
      }
    },

    init( id , title = ''){
      this.reset()
      this.id = id
      this.title = title
      this.query()
      this.visible = true
    }, 

    reset(){
      // for(let i in this.form){
      //   this.form[i] = this.data.info[i]
      // }
      this.$utils.fill( this.form , this.data.info )
    },

    save(){
      let params = { ...this.form }
      this.$request.orderUpdate(params).then(resp => {
        if(!resp.code){
          this.$Message.success('保存成功')
          this.$emit('on-update')
          // this.$keepAlive.update()
        }else{
          this.$Message.error(resp.msg)
        }
      })
    },
    handleQueryLoan(){
      this.loading = true
      this.$request.ciLoanQuery(this.id).then( resp => {
        this.loading = false

        /*
        @ApiModelProperty("征信查询code")
        private String creditCode;
        @ApiModelProperty("贷款金额，计算，客户的贷款本金")
        private BigDecimal loanAmount;
        @ApiModelProperty("贷款金额，计算，客户的贷款本金")
        private BigDecimal realLoanAmount;
        @ApiModelProperty("首月月还，计算，首月还款金额")
        private BigDecimal firstPayAmount;
        @ApiModelProperty("每期月还，计算，首月之后的每月还款金额")
        private BigDecimal monthlyPayFinalAmount;
        @ApiModelProperty(" 金融服务费，计算，资金方收取的金融服务费")
        private BigDecimal financeFee;
        @ApiModelProperty("银行手续费，计算，银行收取的手续费")
        private BigDecimal bankFee;
        @ApiModelProperty("贷款担保额，计算，本息合计")
        private BigDecimal guaranteeAmount;
        @ApiModelProperty("月还初步，计算")
        private BigDecimal monthlyPayAmount;
        @ApiModelProperty("实际每月还款额，计算")
        private BigDecimal realMonthlyPayAmount;
        */
        const fields = [
          // {key:'creditCode' , label:'征信查询code'},
          {key:'loanAmount' , label:'贷款金额'},
          {key:'realLoanAmount' , label:'实际贷款金额'},
          {key:'firstPayAmount' , label:'首月月还'},
          {key:'monthlyPayFinalAmount' , label:'每期月还'},
          {key:'financeFee' , label:'金融服务费'},
          {key:'bankFee' , label:'银行手续费'},
          {key:'guaranteeAmount' , label:'贷款担保额'},
          {key:'monthlyPayAmount' , label:'月还初步'},
          // {key:'realMonthlyPayAmount' , label:'实际每月还款额'},
        ]

        if(!resp.code){
          //this.$Message.success('操作成功')
          //this.query()
          this.$Modal.info({
            render: (h) => {
              return h('div' , createLabel(fields , resp.data ,h))
            }
          })
        }else{
          this.$Message.error(resp.msg)
        }
      })
    },
    handleApply(){
      this.$ui.confirm(this.$request.orderApplyLoan ,  `确定申请贷款 ？`)({id:this.id}).then( resp => {
        if(!resp.code){
          this.$Message.success('操作成功')
          this.list()
        }else{
          this.$Message.error(resp.msg)
        }
      })
    },

    handleVerifyLoan(){
      this.$ui.confirm(this.$request.ciLoanVerify ,  `确定进行面签数据校验  ？`)(this.id).then( resp => {
        if(!resp.code){
          this.$Message.success('操作成功')
        }else{
          this.$Message.error(resp.msg)
        }
      })
    },

    handlePushNotify(){
      this.$ui.confirm(this.$request.orderPushNotify ,  `确定推送消息 ？`)({id:this.id}).then( resp => {
        if(!resp.code){
          this.$Message.success('操作成功')
          this.list()
        }
      })
    },

    handleSubmit(name){
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误')
        }
      })
    },

    handleClose() {

    }
  }
}

</script>